<div class="pt-3" *ngIf="customerNotFound">
  <h2>Customer not found.</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="!customerNotFound && (serverError === null)">

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Search by subject"
             [(ngModel)]="filters.subject_contains"
             (ngModelChange)="handleFilterChange()">
    </div>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; height: 39px;">
          <span style="position: relative; top: -2px;">Emails</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Date&nbsp;/&nbsp;Time</th>
        <th scope="col">Recipient</th>
        <th scope="col">Subject</th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingEmails">
      <tr *ngFor="let email of emailsList.results"
          class="clickable-row"
          (click)="openEmail(email)">
        <td>
          <span style="white-space: nowrap">{{ dateStringFromISO8601(email.created_at) }}</span>,
          <br>
          <span style="white-space: nowrap">{{ timeStringFromISO8601(email.created_at) }}</span>
        </td>
        <td>{{ email.to_emails.join(', ') }}</td>
        <td>
          {{ email.subject }}
          <span *ngIf="!email.sent_successfully"
                class="badge badge-danger ml-2"
                [ngbTooltip]="email.error || 'Send failed'">
            Failed
          </span>
        </td>
      </tr>
      <tr *ngIf="emailsList.results.length === 0">
        <td colspan="99" class="text-muted">No emails</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingEmails">
      <tr>
        <td colspan="99" class="text-muted">Loading emails...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
